var map = {
	"./BaseButton.vue": "wmdn",
	"./BaseDate.vue": "ATat",
	"./BaseDatetime.vue": "SKAd",
	"./BaseInput.vue": "qp/k",
	"./BaseInputNumber.vue": "ZlWQ",
	"./BaseInputSelect.vue": "8Jok",
	"./BaseSearchClientList.vue": "B7zF",
	"./BaseSearchGoodsList.vue": "d4e9",
	"./BaseSearchStorageList.vue": "8Phm",
	"./BaseSelect.vue": "guiD",
	"./BaseTextarea.vue": "R7Bi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sIRd";


//////////////////
// WEBPACK FOOTER
// ./src/components/base nonrecursive Base[\w-]+\.vue$
// module id = sIRd
// module chunks = 1